import { render, staticRenderFns } from "./ImageInput.vue?vue&type=template&id=0fef8754&"
import script from "./ImageInput.vue?vue&type=script&lang=ts&"
export * from "./ImageInput.vue?vue&type=script&lang=ts&"
import style0 from "./ImageInput.vue?vue&type=style&index=0&id=0fef8754&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports